import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_DOCUMENT_LIST_EMD_STORE_NAME, GetDocumentListEmdState } from './get-document-list-emd.state';

/** Select GetDocumentListEmd State */
export const selectGetDocumentListEmdState = createFeatureSelector<GetDocumentListEmdState>(
  GET_DOCUMENT_LIST_EMD_STORE_NAME
);

/** Select GetDocumentListEmd isPending status */
export const selectGetDocumentListEmdIsPendingStatus = createSelector(
  selectGetDocumentListEmdState,
  (state) => !!state.isPending
);

/** Select GetDocumentListEmd isFailure status */
export const selectGetDocumentListEmdIsFailureStatus = createSelector(
  selectGetDocumentListEmdState,
  (state) => !!state.isFailure
);
